module.exports = __webpack_public_path__ + "img/icon-2.447d6a34.svg";